export default __webpack_public_path__ + "static/media/logo-no-text.fcc06803.png";